import React from 'react'

import AccordionItem from './AccordionItem'

export default function Accordion( props ) {

	const { children, noBorder, openOnLoad } = props

	return (
		<div className={`accordion ${ noBorder ? 'accordion--no-border' : '' }`}>
			<div className="accordion__container">

				{ children.length ? (
					<>
						{ children.map( ( child, i ) => (
							<React.Fragment key={ i }>
								<AccordionItem data={ child } openOnLoad={ openOnLoad && !i ? true : false } />
							</React.Fragment>
						) ) }
					</>
				) : (
					<AccordionItem data={ children } openOnLoad={ openOnLoad ? true : false } />
				) }

			</div>
		</div>
	)
}